import Location from 'records/Location';
import Base from 'records/Base';

import {
  LOCATION_ASYNC_ACTION_START,
  LOCATION_ASYNC_ACTION_ERROR,
  LOCATION_ASYNC_UPDATE_SUCCESS,
  LOCATION_UPDATE_SUCCESS,
  LOCATION_RESET_STATE,
} from 'actions/location';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new Location(),
});

const actionsMap = {
  [LOCATION_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [LOCATION_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [LOCATION_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Location(action.data),
    });
  },
  [LOCATION_UPDATE_SUCCESS]: (state, action) => {
    return state.mergeDeep({
      data: action.data,
    });
  },
  [LOCATION_RESET_STATE]: () => {
    return initialState;
  },
};

export default function location(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
